import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e6b942d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"display":"none"},
  id: "btnPrintOrder"
}
const _hoisted_2 = { style: {"display":"none"} }
const _hoisted_3 = {
  ref: "printOrder",
  id: "printOrder"
}
const _hoisted_4 = {
  key: 0,
  id: "invoice-POS"
}
const _hoisted_5 = { class: "table-order" }
const _hoisted_6 = { id: "mid" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "orderIndex" }
const _hoisted_12 = { class: "orderNb" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "orderDate orderDate-header orderDate-center orderDate-uppercase" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "orderDate orderDate-header orderDate-center orderDate-uppercase" }
const _hoisted_19 = {
  class: "bold",
  style: {"display":"inline"}
}
const _hoisted_20 = { class: "orderDate orderDate-header orderDate-center orderDate-uppercase" }
const _hoisted_21 = {
  key: 0,
  class: "bold",
  style: {"display":"inline"}
}
const _hoisted_22 = {
  key: 0,
  class: "bold"
}
const _hoisted_23 = {
  key: 1,
  class: "bold"
}
const _hoisted_24 = {
  key: 1,
  class: "bold",
  style: {"display":"inline"}
}
const _hoisted_25 = {
  key: 0,
  class: "bold"
}
const _hoisted_26 = {
  key: 1,
  class: "bold"
}
const _hoisted_27 = {
  key: 2,
  class: "bold",
  style: {"display":"inline"}
}
const _hoisted_28 = {
  key: 0,
  class: "bold"
}
const _hoisted_29 = {
  key: 1,
  class: "bold"
}
const _hoisted_30 = { id: "bot" }
const _hoisted_31 = { id: "table" }
const _hoisted_32 = { class: "table-order" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "tabletitle tabletitle-header-products" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "qproduct" }, [
    /*#__PURE__*/_createElementVNode("b", null, "QxProduit")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "price" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Prix TTC")
  ])
], -1))
const _hoisted_34 = { class: "text-left width-element-left tableitem" }
const _hoisted_35 = { class: "itemtext itemtext-item-product" }
const _hoisted_36 = {
  key: 0,
  class: "text-left tableitem border-dash-top"
}
const _hoisted_37 = {
  key: 0,
  class: "subelement-type"
}
const _hoisted_38 = {
  key: 0,
  class: "itemtext itemtext-subElement"
}
const _hoisted_39 = {
  key: 1,
  class: "itemtext itemtext-subElement"
}
const _hoisted_40 = {
  key: 1,
  class: "subelement-type"
}
const _hoisted_41 = { class: "itemtext itemtext-subElement" }
const _hoisted_42 = { style: {"float":"right"} }
const _hoisted_43 = { class: "itemtext itemtext-subElement-price" }
const _hoisted_44 = { class: "text-right tableitem border-unset" }
const _hoisted_45 = {
  key: 0,
  class: "itemtext itemtext-promo-product itemtext-price"
}
const _hoisted_46 = { class: "itemtext itemtext-promo-product itemtext-price" }
const _hoisted_47 = { class: "table-order" }
const _hoisted_48 = { class: "tabletitle tabletitle-total font-weight-bold" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left width-element-left tableitem" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "itemtext itemtext-amount" }, " Total de la commande")
], -1))
const _hoisted_50 = { class: "text-right tableitem border-unset" }
const _hoisted_51 = { class: "itemtext itemtext-amount" }
const _hoisted_52 = {
  key: 0,
  class: "tabletitle tabletitle-total font-weight-bold"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left width-element-left tableitem" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "itemtext itemtext-amount" }, " Total de Réduction : ")
], -1))
const _hoisted_54 = { class: "text-right tableitem border-unset" }
const _hoisted_55 = { class: "itemtext itemtext-amount" }
const _hoisted_56 = { class: "tabletitle tabletitle-total font-weight-bold" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left width-element-left tableitem" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "itemtext itemtext-amount" }, " Frais de livraison ")
], -1))
const _hoisted_58 = { class: "text-right tableitem border-unset" }
const _hoisted_59 = { class: "itemtext itemtext-amount" }
const _hoisted_60 = { class: "tabletitle tabletitle-total font-weight-bold" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left width-element-left tableitem" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "itemtext itemtext-amount" }, " Total HT ")
], -1))
const _hoisted_62 = { class: "text-right tableitem border-unset" }
const _hoisted_63 = { class: "itemtext itemtext-amount" }
const _hoisted_64 = { class: "tabletitle tabletitle-total font-weight-bold" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left width-element-left tableitem" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "itemtext itemtext-amount" }, " Total TTC ")
], -1))
const _hoisted_66 = { class: "text-right tableitem border-unset" }
const _hoisted_67 = { class: "itemtext itemtext-amount" }
const _hoisted_68 = { class: "mb-2 orderDate orderDate-footer orderDate-left" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Commentaire", -1))
const _hoisted_71 = {
  key: 0,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Nom du client", -1))
const _hoisted_73 = {
  key: 1,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Nom du client", -1))
const _hoisted_75 = {
  key: 2,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Nom du client", -1))
const _hoisted_77 = {
  key: 3,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Téléphone", -1))
const _hoisted_79 = {
  key: 4,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Téléphone", -1))
const _hoisted_81 = {
  key: 5,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Téléphone", -1))
const _hoisted_83 = {
  key: 6,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Adresse client", -1))
const _hoisted_85 = {
  key: 7,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Adresse client", -1))
const _hoisted_87 = {
  key: 8,
  class: "mb-2 orderDate orderDate-footer orderDate-left"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "bold font-12" }, "Adresse client", -1))
const _hoisted_89 = { class: "mb-2 orderDate orderDate-thank orderDate-center last-item-mt" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "SIRET", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Code NAF", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TVA", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orderDate orderDate-thank orderDate-center orderDate-uppercase" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "MERCI POUR VOTRE COMMANDE - A BIENTOT")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_1, [
      _createTextVNode("Print local range")
    ])), [
      [_directive_print, '#printOrder']
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.statePrintOrder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (_ctx.storeInfoState?.name)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                _createTextVNode(_toDisplayString(_ctx.storeInfoState?.name) + ", ", 1),
                                (_ctx.storeInfoState?.address)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.storeInfoState?.address), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.storeInfoState?.phone)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.storeInfoState?.phone), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.statePrintOrder?.counter_order_index ?? 1), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("strong", null, "Commande n° " + _toDisplayString(_ctx.statePrintOrder?.id), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.statePrintOrder?.created_at)), 1)
                      ])
                    ])
                  ]),
                  (_ctx.statePrintOrder?.planified)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.statePrintOrder?.type == 'liv')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "A livrer"))
                              : _createCommentVNode("", true),
                            (_ctx.statePrintOrder?.type == 'cac')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_16, "A emporter"))
                              : _createCommentVNode("", true),
                            _createTextVNode(" le " + _toDisplayString(_ctx.formatDateTime(_ctx.statePrintOrder?.planified_at)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.statePrintOrder?.type == 'at_place')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_18, [
                            _createTextVNode(" **** "),
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.statePrintOrder?.table?.table_number), 1),
                            _createTextVNode(" **** ")
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_20, [
                        _createTextVNode(" **** "),
                        (_ctx.statePrintOrder?.type == 'liv')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                              _createTextVNode(" Livraison"),
                              (_ctx.statePrintOrder?.is_paid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, ", Payée"))
                                : _createCommentVNode("", true),
                              (!_ctx.statePrintOrder?.is_paid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, ", non payée"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.statePrintOrder?.type == 'cac')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                              _createTextVNode(" Emporter"),
                              (_ctx.statePrintOrder?.is_paid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, ", Payée"))
                                : _createCommentVNode("", true),
                              (!_ctx.statePrintOrder?.is_paid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, ", non payée"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.statePrintOrder?.type == 'at_place')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                              _createTextVNode(" Sur place"),
                              (_ctx.statePrintOrder?.is_paid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, ", Payée"))
                                : _createCommentVNode("", true),
                              (!_ctx.statePrintOrder?.is_paid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, ", non payée"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createTextVNode(" **** ")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("table", _hoisted_32, [
                    _hoisted_33,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statePrintOrder?.elements_order, (elementOrder) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elementOrder.id,
                        class: "tabletitle tabletitle-list-products font-weight-bold"
                      }, [
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(elementOrder.quantity) + " x " + _toDisplayString(elementOrder.finalName), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementOrder.sub_elements_order, (subElement) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: subElement.id,
                              class: "subelement"
                            }, [
                              (subElement?.type)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    (subElement.type == 'ing')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                          (subElement?.sub_product?.group?.max != null)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(subElement.sub_product?.name), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(subElement.sub_product?.name), 1))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (subElement.type == 'sup')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                          _createElementVNode("span", _hoisted_41, _toDisplayString(subElement.quantity) + " x " + _toDisplayString(subElement.sub_product?.name), 1),
                                          _createElementVNode("span", _hoisted_42, [
                                            _createElementVNode("span", _hoisted_43, _toDisplayString(subElement.price.toFixed(2)) + " €", 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("td", _hoisted_44, [
                          (elementOrder.discountPromotion)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(elementOrder?.discountPromotion?.TotalPriceWithSubProducts?.toFixed(2)) + " € ", 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_46, _toDisplayString(elementOrder.total_amount_element_subelements?.toFixed(2)) + " € ", 1)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("table", _hoisted_47, [
                    _createElementVNode("tr", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("td", _hoisted_50, [
                        _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.statePrintOrder?.totalPriceOrder?.toFixed(2)) + " € ", 1)
                      ])
                    ]),
                    (_ctx.statePrintOrder?.totalDiscount !== 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("td", _hoisted_54, [
                            _createElementVNode("p", _hoisted_55, " - " + _toDisplayString(_ctx.statePrintOrder?.totalDiscount?.toFixed(2)) + " € ", 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("td", _hoisted_58, [
                        _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.statePrintOrder?.fees.toFixed(2)) + " € ", 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("td", _hoisted_62, [
                        _createElementVNode("p", _hoisted_63, _toDisplayString((_ctx.statePrintOrder?.total_amount / 1.1).toFixed(2)) + " € ", 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_64, [
                      _hoisted_65,
                      _createElementVNode("td", _hoisted_66, [
                        _createElementVNode("p", _hoisted_67, _toDisplayString((_ctx.statePrintOrder?.total_amount).toFixed(2)) + " € ", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                (_ctx.statePrintOrder?.comment)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_69, [
                      _hoisted_70,
                      _createTextVNode(" : " + _toDisplayString(_ctx.statePrintOrder?.comment), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.statePrintOrder?.customerstore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("p", null, [
                      _hoisted_72,
                      _createTextVNode(" : " + _toDisplayString(_ctx.statePrintOrder?.customerstore?.firstName) + " " + _toDisplayString(_ctx.statePrintOrder?.customerstore?.lastName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.statePrintOrder?.borne_cust_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _createElementVNode("p", null, [
                      _hoisted_74,
                      _createTextVNode(" : " + _toDisplayString(_ctx.statePrintOrder?.borne_cust_name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.statePrintOrder?.customerstore && _ctx.statePrintOrder?.type == 'liv' && _ctx.statePrintOrder?.deliveryaddress?.firstName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("p", null, [
                      _hoisted_76,
                      _createTextVNode(" : " + _toDisplayString(_ctx.statePrintOrder?.deliveryaddress?.firstName) + " " + _toDisplayString(_ctx.statePrintOrder?.deliveryaddress?.lastName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.statePrintOrder?.type != 'liv' && _ctx.statePrintOrder?.customer?.phone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("p", null, [
                      _hoisted_78,
                      _createTextVNode(" : " + _toDisplayString(_ctx.statePrintOrder?.customer?.phone), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.statePrintOrder?.customerstore?.phone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createElementVNode("p", null, [
                      _hoisted_80,
                      _createTextVNode(" : " + _toDisplayString(_ctx.statePrintOrder?.customerstore?.phone), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.statePrintOrder?.customerstore && _ctx.statePrintOrder?.type == 'liv' && _ctx.statePrintOrder?.deliveryaddress?.phone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("p", null, [
                      _hoisted_82,
                      _createTextVNode(" : " + _toDisplayString(_ctx.statePrintOrder?.deliveryaddress?.phone), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.statePrintOrder?.customerstore && _ctx.statePrintOrder?.type == 'liv' && _ctx.statePrintOrder?.customer?.address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createElementVNode("p", null, [
                      _hoisted_84,
                      _createTextVNode(" : " + _toDisplayString(_ctx.formatAddress(_ctx.statePrintOrder?.deliveryaddress?.address)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.statePrintOrder?.customerstore && _ctx.statePrintOrder?.type == 'liv' && _ctx.statePrintOrder?.deliveryaddress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                    _createElementVNode("p", null, [
                      _hoisted_86,
                      _createTextVNode(" : " + _toDisplayString(_ctx.formatAddress(_ctx.statePrintOrder?.deliveryaddress?.address)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.statePrintOrder?.customerstore?.address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    _createElementVNode("p", null, [
                      _hoisted_88,
                      _createTextVNode(" : " + _toDisplayString(_ctx.formatAddress(_ctx.statePrintOrder?.customerstore?.address)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_89, [
                (_ctx.storeInfoState?.siret)
                  ? (_openBlock(), _createBlock(_component_P, { key: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_90,
                        _createTextVNode(" :" + _toDisplayString(_ctx.storeInfoState?.siret), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.storeInfoState?.code_naf)
                  ? (_openBlock(), _createBlock(_component_P, { key: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_91,
                        _createTextVNode(" :" + _toDisplayString(_ctx.storeInfoState?.code_naf), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.storeInfoState?.tva)
                  ? (_openBlock(), _createBlock(_component_P, { key: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_92,
                        _createTextVNode(" :" + _toDisplayString(_ctx.storeInfoState?.tva), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_93
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ])
  ], 64))
}